import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/compat/firestore';
import { Medal } from '../models/medal';
import { AlertController } from '@ionic/angular';
import { User } from '../models/user';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Visit } from '../models/visit';
import { Capacitor } from '@capacitor/core';

const TABLE = 'medals';

@Injectable({
  providedIn: 'root',
})
export class MedalsService {
  private collectionRef: AngularFirestoreCollection<Medal>;

  constructor(
    private db: AngularFirestore,
    public alertController: AlertController,
    private http: HttpClient
  ) {
    this.collectionRef = this.db.collection(TABLE);
  }

  getMedals() {
    return this.db
      .collection<Medal>(TABLE, (ref) => ref.orderBy('order', 'asc'))
      .valueChanges({ idField: '_id' });
  }

  async showAlertMedal(medalName: string) {
    const alert = await this.alertController.create({
      header: '🏅Felicidades🎉',
      subHeader: `Has conquistado la Medalla "${medalName}"`,
      message: '¡Enhorabuena por tu logro!',
      animated: true,
      buttons: ['Listo'],
      cssClass: 'medal-alert',
    });

    await alert.present();
  }

  SetDataUserMedal(user: User): Promise<void> {
    const tableUser = 'users';
    const userRef: AngularFirestoreDocument<any> = this.db.doc(
      `${tableUser}/${user.uid}`
    );
    return userRef.set(
      { medalsObtained: user.medalsObtained },
      { merge: true }
    );
  }


  inviteFriendsToDownloadApp(user: User, visit: Visit): Observable<any> {
    const data = {
      userPhoneNumber: user.phoneNumber,
      urlPhotoVisit: visit.urlPhoto
    };
    return this.http.post<any>(
      `${environment.apiBackendMiradores}/chat/send-invite-after-first-visit`,
      data
    );
  }


  inviteFriendsAfter5Visits(user: User, visit: Visit[]): Observable<any> {
    const data = {
      userPhoneNumber: user.phoneNumber,
      urlPhotoVisit: visit[visit.length].urlPhoto,
      cantVisits: visit.length,
    }

    return this.http.post<any>(
      `${environment.apiBackendMiradores}/chat/send-invite-after-5-visits`,
      data
    );
  }


  requestAppRatingAfter8Visits(user: User, visits: Visit[]): Observable<any> {

    let link = Capacitor.getPlatform() == 'ios'  ? "https://apps.apple.com/co/app/miradores-medell%C3%ADn/id6449554555" : "https://play.google.com/store/apps/details?id=co.miradores.med&hl=es_GT&gl=US";

    const data = {
      userPhoneNumber: user.phoneNumber,
      cantVisits: visits.length,
      link
    }

    return this.http.post<any>(
      `${environment.apiBackendMiradores}/chat/rate-app-after-8-visits`,
      data
    );
  }

  sendFirstVisitGoogleReviewMessage(miradorName:string, phoneNumber:string): Observable<any> {
    return this.http.post(`${environment.apiBackendMiradores}/chat/send-first-visit-google-review-message`, { miradorName, phoneNumber });
  }
}
